import styled from "styled-components"
import src from "../../../assets/images/important-icon.png";

const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: var(--colorBlueLight);
    border: 1px solid var(--colorBlue);
    padding: 13px 24px;
    border-radius: 5px;
`;

const TopInfo = styled.span`
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
`;

interface ImportantTextProps {}

export const ImportantText = ({children}: React.PropsWithChildren<ImportantTextProps>) => (
    <TextWrapper>
        <TopInfo>
            <img src={src} width={20} height={20}/>
            <span className="text sizeMd styleBold colorBlue">Importante</span>
        </TopInfo>
        <div>
            {children}
        </div>
    </TextWrapper>
)